import { getItemMaker, getRecipeMaker, mkIQ as n } from "./tools";

const jewel = getItemMaker("laboratory jewels");
export const labJewels = [
  jewel("Amethyst Rhinestone"),
  jewel("Purple Navette"),
  jewel("Purple Rhombol"),
  jewel("Sapphire Rhinestone"),
  jewel("Sapphire Navette"),
  jewel("Sapphire Rhombol"),
  jewel("Sapphire Pyramite"),
  jewel("Pyrite Rhinestone"),
  jewel("Pyrite Navette"),
  jewel("Pyrite Rhombol"),
  jewel("Pyrite Pyramite"),
  jewel("Emerald Rhinestone"),
  jewel("Emerald Navette"),
  jewel("Emerald Rhombol"),
  jewel("Emerald Pyramite"),
  jewel("Emerald Ulthurite"),
  jewel("Black Diamond Rhinestone"),
  jewel("Black Diamond Ulthurite"),
  jewel("Pure Opal Rhinestone"),
  jewel("Pure Opal Navette"),
  jewel("Pure Opal Rhombol"),
];

const chip = getItemMaker("laboratory nanochips");
export const labChips = [
  chip("Grounded Nanochip"),
  chip("Grounded Motherboard"),
  chip("Grounded Software"),
  chip("Grounded Processor"),
  chip("Potato Chip"),
  chip("Conductive Nanochip"),
  chip("Conductive Motherboard"),
  chip("Conductive Software"),
  chip("Conductive Processor"),
  chip("Chocolatey Chip"),
  chip("Galvanic Nanochip"),
  chip("Galvanic Motherboard"),
  chip("Galvanic Software"),
  chip("Galvanic Processor"),
  chip("Wood Chip"),
  chip("Silkrode Nanochip"),
  chip("Silkrode Motherboard"),
  chip("Silkrode Software"),
  chip("Silkrode Processor"),
  chip("Poker Chip"),
  chip("Omega Nanochip"),
  chip("Omega Motherboard"),
];

const r = getRecipeMaker("laboratory");
export const jewelRecipes = [
  r(
    "Amethyst Rhinestone",
    n("Strung Jewels", 5),
    n("Egg", 2000),
    n("Grasslands Spice", 200),
  ),
  r(
    "Purple Navette",
    n("Googley Eyes", 5),
    n("Pie", 2000),
    n("Jungle Spice", 200),
  ),
  r(
    "Purple Rhombol",
    n("1 HR Time Candy", 10),
    n("Spaghetti", 2000),
    n("Encroaching Forest Spice", 200),
  ),
  r(
    "Sapphire Rhinestone",
    n("Red Frisbee", 10),
    n("Garlic Bread", 5000),
    n("Tree Interior Spice", 400),
  ),
  r(
    "Sapphire Navette",
    n("Woodular Circle", 25),
    n("Pizza", 5000),
    n("Stinky Sewers Spice", 400),
  ),
  r(
    "Sapphire Rhombol",
    n("Golden Plop", 30),
    n("Pancakes", 5000),
    n("Desert Oasis Spice", 400),
  ),
  r(
    "Sapphire Pyramite",
    n("Guild Giftbox", 2),
    n("Cabbage", 5000),
    n("Beach Docks Spice", 400),
  ),
  r(
    "Pyrite Rhinestone",
    n("Glass Shard", 50),
    n("Dango", 10000),
    n("Coarse Mountains Spice", 1500),
  ),
  r(
    "Pyrite Navette",
    n("Trimmed Rune Platelegs", 2),
    n("Octoplop", 10000),
    n("Twilight Desert Spice", 1500),
  ),
  r(
    "Pyrite Rhombol",
    n("Nuget Cake", 50),
    n("Canopy", 10000),
    n("The Crypt Spice", 1500),
  ),
  r(
    "Pyrite Pyramite",
    n("Ghost", 50),
    n("Cheese", 10000),
    n("Frosty Peaks Spice", 1500),
  ),
  r(
    "Emerald Rhinestone",
    n("Baba Yaga Baby Eggs", 1),
    n("Eggplant", 25000),
    n("Tundra Outback Spice", 5000),
  ),
  r(
    "Emerald Navette",
    n("Yellow Snowflake", 80),
    n("Wild Boar", 25000),
    n("Crystal Caverns Spice", 5000),
  ),
  r(
    "Emerald Rhombol",
    n("Ice Age 3", 120),
    n("Riceball", 25000),
    n("Pristalle Lake Spice", 5000),
  ),
  r(
    "Emerald Pyramite",
    n("Black Lense", 150),
    n("Durian Fruit", 25000),
    n("Nebulon Mantle Spice", 5000),
  ),
  r(
    "Emerald Ulthurite",
    n("Lost Batteries", 200),
    n("Bunt Cake", 25000),
    n("Starfield Skies Spice", 5000),
  ),
  r(
    "Black Diamond Rhinestone",
    n("Pearler Shell", 300),
    n("Leek", 100000),
    n("Starfield Skies Spice", 10000),
  ),
  r(
    "Black Diamond Ulthurite",
    n("Voodofish", 10000),
    n("Pretzel", 100000),
    n("Shores of Eternity Spice", 10000),
  ),
  r(
    "Pure Opal Rhinestone",
    n("Leafy Droplet", 3000000),
    n("Ratatouey", 1000000),
    n("Spirit Fields Spice", 10000),
  ),
  r(
    "Pure Opal Navette",
    n("Dark Lantern", 1000),
    n("Sticky Bun", 10000000),
    n("Bamboo Forest Spice", 10000),
  ),
  r(
    "Pure Opal Rhombol",
    n("Tottoise", 5000),
    n("Bill Jack Pepper", 100000000),
    n("Lullaby Airways Spice", 10000),
  ),
];

export const nanochipRecipes = [
  r(
    "Grounded Nanochip",
    n("Copper Ore", 20000),
    n("Turkey a la Thank", 100),
    n("Grasslands Spice", 100),
  ),
  r(
    "Grounded Motherboard",
    n("Oak Logs", 30000),
    n("Egg", 100),
    n("Grasslands Spice", 100),
  ),
  r(
    "Grounded Software",
    n("Goldfish", 20000),
    n("Pie", 100),
    n("Jungle Spice", 100),
  ),
  r(
    "Grounded Processor",
    n("Pocket Sand", 10000),
    n("Frenk Fries", 100),
    n("Jungle Spice", 100),
  ),
  r(
    "Potato Chip",
    n("Fly", 20000),
    n("Corn", 100),
    n("Encroaching Forest Spice", 100),
  ),
  r(
    "Conductive Nanochip",
    n("Veiny Logs", 100000),
    n("Pizza", 100),
    n("Tree Interior Spice", 100),
  ),
  r(
    "Conductive Motherboard",
    n("Gold Ore", 100000),
    n("Corndog", 100),
    n("Stinky Sewers Spice", 100),
  ),
  r(
    "Conductive Software",
    n("Crabbo", 10000),
    n("Dango", 100),
    n("Stinky Sewers Spice", 100),
  ),
  r(
    "Conductive Processor",
    n("Mosquisnow", 100000),
    n("Croissant", 100),
    n("Desert Oasis Spice", 100),
  ),
  r(
    "Chocolatey Chip",
    n("Pinion Spur", 200000),
    n("Cheese", 100),
    n("Beach Docks Spice", 100),
  ),
  r(
    "Galvanic Nanochip",
    n("Sippy Straw", 100000),
    n("Cheesy Bread", 100),
    n("Coarse Mountains Spice", 100),
  ),
  r(
    "Galvanic Motherboard",
    n("Skelefish", 250000),
    n("Riceball", 100),
    n("Twilight Desert Spice", 100),
  ),
  r(
    "Galvanic Software",
    n("Dementia Ore", 300000),
    n("Durian Fruit", 100),
    n("The Crypt Spice", 100),
  ),
  r(
    "Galvanic Processor",
    n("Wurm Tail", 100000),
    n("Bunt Cake", 100),
    n("Frosty Peaks Spice", 100),
  ),
  r(
    "Wood Chip",
    n("Cubed Logs", 250000),
    n("Leek", 100),
    n("Tundra Outback Spice", 100),
  ),
  r(
    "Silkrode Nanochip",
    n("Lugi Bracket", 2000000),
    n("Pretzel", 100),
    n("Crystal Caverns Spice", 100),
  ),
  r(
    "Silkrode Motherboard",
    n("Squishy Soul", 2000000),
    n("Mashed Potato", 100),
    n("Pristalle Lake Spice", 100),
  ),
  r(
    "Silkrode Software",
    n("Fairy", 2000000),
    n("Wedding Cake", 100),
    n("Pristalle Lake Spice", 100),
  ),
  r(
    "Silkrode Processor",
    n("Blobfish", 2000000),
    n("Whipped Cocoa", 100),
    n("Nebulon Mantle Spice", 100),
  ),
  r(
    "Poker Chip",
    n("PVC Pipe", 2000000),
    n("Soda", 100),
    n("Nebulon Mantle Spice", 100),
  ),
  r(
    "Omega Nanochip",
    n("Fairy", 10000000),
    n("Buncha Banana", 100),
    n("Starfield Skies Spice", 100),
  ),
  r(
    "Omega Motherboard",
    n("Kraken", 10000000),
    n("Cotton Candy", 100),
    n("Shores of Eternity Spice", 100),
  ),
];
